import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Truck, OilPipe } from "../../constant";
import { motion } from "framer-motion";
import { useRef, useState, useEffect } from "react";

export default function FuelManagementLanding() {
  const truckRef = useRef(null);
  //const chartRef = useRef(null);
  const pipeRef = useRef(null);
  const [truckWidth, setTruckWidth] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (truckRef.current) {
      setTruckWidth(truckRef.current.offsetWidth);
    }
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "50vh", md: "50vh" },
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1,
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
           playsInline
  preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src="/HomeBGVideo.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
          padding: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          margin: "0 auto",
          alignItems: "center",
        }}
      >
        {/* Title Box */}
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{
            width: "100%",
            maxWidth: "1200px",
            textAlign: "left",
            py: 4,
            mt: 4,
          }}
        >
          <Grid container spacing={0}>
            <Grid xs={12} sm={12} md={8} lg={8}>
              <Typography
                variant="h2"
                sx={{
                  background: 'linear-gradient(262.41deg, #1DA1F2 -8.32%, #6843EC 93.3%)',
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: { xs: "24px", sm: "32px", md: "48px" },
                  fontWeight: 700,
                  mb: 2,
                  textAlign: "start",
                  letterSpacing: isMobile ? "0px" : "-2.4px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {`Integrated Transport Management System`}
              </Typography>
            </Grid>
            <Grid xs={12} sm={12} md={5} lg={5}>
              <Typography
                  sx={{
                    color: "#fff",
                    fontSize: { xs: "14px", md: "16px" },
                    lineHeight: 1.8,
                    textAlign: "start",
                    marginTop: 5,
                  }}
                >
{"Transform fleet operations with a unified intelligent transport platform designed to monitor, optimize and secure every aspect of vehicle movement and driver performance. Powered by AI, IoT and real-time analytics, the platform delivers complete operational visibility across transport ecosystems."}                </Typography>
            </Grid>
          </Grid>
        </Box>
        {/* Animation Box */}
        <Box sx={{ position: "relative", width: "100%", height: "280px" }}>
        {/* Truck Animation */}
        <motion.div
          ref={truckRef}
          initial={{ x: "100vw" }}
          animate={{ x: isMobile ? `calc(40% - ${truckWidth / 2}px)` :  `${truckWidth}px`}}
          transition={{ duration: 1, ease: "easeOut" }}
          style={{ position: "absolute", bottom: isMobile && -25}}
        >
          <img src={Truck} alt="Truck" style={{ width: isMobile ? "500px" : "100%" }} /> 
        </motion.div>

        {/* Charts Animation
        <motion.div
          ref={chartRef}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
          style={{
            position: "absolute",
            top: isMobile ? "30%" : "40%",
            left: isMobile ? "20%" : "30%"
          }}
        >
          <img
            src={TruckChart}
            alt="Chart"
            style={{ position: "absolute",width: isMobile ? "100px" : "100%" }}
          />
          <img
            src={FuelChart}
            alt="Fuel"
            style={{ 
              position: "relative",
              left: '100%',
              width: isMobile ? "100px" : "100%"
            }}
          />
        </motion.div> */}

        {/* Oil Pipe Animation */}
        <motion.div
          ref={pipeRef}
          initial={{ x: "100vw" }}
          animate={{ x: isMobile ? "1%" : "-30%" }}
          transition={{ delay: 0.8, duration: 0.5 }}
          style={{
            position: "absolute",
            top: isMobile ? "30%" : "0%",
            right: 0, 
            left: isMobile && "45%"
          }}
        >
          <img 
            src={OilPipe} 
            alt="Pipe" 
            style={{ width: isMobile ? "250px" : "80%" }} 
          />
        </motion.div>
      </Box>
      </Box>
    </Box>
  );
}
